import "slick-carousel";
import common from "../modules/common";

const home = {
  init: function () {
    home.slider.load();
    home.init_partners();
    home.init_testimonials();
  },

  slider: {
    load: function () {
      $(".hero__slider").on("init", function () {
        common.bLazy.load($(".hero__lazy"));
        $(".hero__dots__image").eq(0).addClass("active");
        $(".hero__dots__image").click(function () {
          $(".hero__dots__numbers li").eq($(this).index()).click();
        });
        $(".hero").addClass("hero--loaded");
      });
      $(".hero__slider").on(
        "beforeChange",
        function (event, slick, currentSlide, nextSlide) {
          $(".hero__dots__image").eq(currentSlide).removeClass("active");
          $(".hero__dots__image").eq(nextSlide).addClass("active");
        }
      );

      var timeout = setTimeout(function () {
        if (!$(".hero--loaded").length) home.slider.init();
      }, 3000);

      var img = new Image();
      img.onload = function () {
        if (!$(".hero--loaded").length) home.slider.init();
      };
      img.src = $(".hero [data-wait-for]").data("wait-for");
      if (img.complete) img.onload();
    },
    init: function () {
      $(".hero__slider").slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: false,
        fade: true,
        autoplay: true,
        dots: true,
        autoplaySpeed: 5000,
        adaptiveHeight: true,
        prevArrow: $(".hero__control--prev"),
        nextArrow: $(".hero__control--next"),
        appendDots: $(".hero__dots__numbers"),
        customPaging: function (slider, i) {
          return (
            '<span class="hero__dots__number">' +
            ("0" + (i + 1)).slice(-2) +
            "</span>"
          );
        },
      });
    },
  },

  init_partners: function () {
    $(".partner__slider").slick({
      infinite: true,
      slidesToShow: 6,
      slidesToScroll: 1,
      swipeToSlide: true,
      prevArrow: $(".partner__slider")
        .prev(".slick__controls")
        .find(".slick__control--prev"),
      nextArrow: $(".partner__slider")
        .prev(".slick__controls")
        .find(".slick__control--next"),
      lazyLoad: "progressive",
      responsive: [
        {
          breakpoint: 1080,
          settings: {
            slidesToShow: 5,
          },
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 4,
          },
        },
        {
          breakpoint: 640,
          settings: {
            slidesToShow: 3,
          },
        },
        {
          breakpoint: 500,
          settings: {
            slidesToShow: 2,
            swipeToSlide: true,
          },
        },
        {
          breakpoint: 430,
          settings: {
            variableWidth: true,
            swipeToSlide: true,
          },
        },
      ],
    });
  },

  init_testimonials: function () {
    $(".testimonial__slider").slick({
      slidesToShow: 1,
      draggable: false,
      infinite: true,
      fade: true,
      prevArrow: $(".testimonial__slider")
        .prev(".slick__controls")
        .find(".slick__control--prev"),
      nextArrow: $(".testimonial__slider")
        .prev(".slick__controls")
        .find(".slick__control--next"),
      dots: false,
      asNavFor: ".testimonial__logos",
    });

    $(".testimonial__logos").slick({
      slidesToShow: 5,
      draggable: true,
      infinite: true,
      arrows: false,
      asNavFor: ".testimonial__slider",
      dots: false,
      responsive: [
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 4,
          },
        },
        {
          breakpoint: 580,
          settings: {
            variableWidth: true,
            swipeToSlide: true,
          },
        },
      ],
    });

    $(".testimonials").on("click", ".testimonial__logo", function () {
      $(".testimonial__logos").slick("slickGoTo", $(this).data("index"));
    });
  },
};

export default home;
